import React, { Component } from 'react';
import { SDate, SHr, SLoad, SNavigation, SText, STheme, SView } from 'servisofts-component2';
import MDL from '../../MDL';
import { FlatList, View } from 'react-native';
import ExpedicionEstado from '../../Components/ExpedicionEstado';
import PopupDinamic from '../../Components/PopupDinamic';
import Mapa from './Mapa';

export default class BottomBoxExpediciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expediciones: MDL.sigestran.expediciones || [],
            active: MDL.backgroundLocation.active,
            data: { cantidad: 0, total: 0 }
        };
    }
    componentDidMount() {
        this.eventChange = MDL.sigestran.addEventListener("changeExpediciones", (e) => {
            console.log("changeExpediciones", e);
            this.setState({ expediciones: e.expediciones });
        })
        this.listener1 = MDL.backgroundLocation.addEventListener("changeStatus", (active) => {
            this.setState({ active: MDL.backgroundLocation.active })
        })

    }

    componentWillUnmount() {
        MDL.sigestran.removeEventListener(this.eventChange);
    }

    render() {
        if (!this.state.active) return null;
        return <PopupDinamic height={200}>

            <SView style={{
                width: "100%",
                borderTopStartRadius: 30,
                borderTopRightRadius: 30,
                backgroundColor: STheme.color.primary,
                height: "100%",
            }} >
                <SView col={"xs-12"} center padding={8} style={{
                    borderTopStartRadius: 30,
                    borderTopRightRadius: 30,
                    backgroundColor: STheme.color.background
                }} >
                    <SView style={{ width: 100, height: 2, backgroundColor: STheme.color.text, borderRadius: 100 }} />
                    <SHr h={8} />
                    <SText bold>EXPEDICIONES EN CURSO {this.state.expediciones.length > 0 ? `( ${this.state.expediciones.length} )` : ""}</SText>
                    {/* <SText bold>{new SDate().transformTimeZone("Europe/Madrid").toString("yyyy-MM-dd hh:mm:ss")}</SText> */}
                </SView>
                <SHr color={STheme.color.text + "11"} h={1} />
                <SView style={{
                    paddingLeft: 8,
                    paddingRight: 8,
                }} flex>
                    <FlatList
                        scrollEnabled={false}
                        data={this.state.expediciones}
                        renderItem={({ item, index }) => <ExpedicionItem key={index} expedicion={item} />}
                        keyExtractor={(item, index) => item.lExpedicionReal_id || index.toString()}
                        ListHeaderComponent={() => <SHr h={16} />}
                        ItemSeparatorComponent={() => <>
                            <SHr h={16} />
                            <SHr h={1} color={STheme.color.text + "11"} />
                            <SHr h={16} />

                        </>}
                        // showsVerticalScrollIndicator={false}
                        contentContainerStyle={{
                            paddingBottom: 16,
                        }}
                    />
                </SView>
            </SView >
        </PopupDinamic>
    }
}

class ExpedicionItem extends Component {
    render() {
        const { expedicion } = this.props;
        const fecha_carga = new SDate(expedicion.dtFechaCargaFormat, 'yyyy-MM-dd hh:mm:ss')
        const fecha_descarga = new SDate(expedicion.dtFechaDescargaFormat, 'yyyy-MM-dd hh:mm:ss');
        return <SView col={"xs-12"} padding={4} onPress={() => {
            SNavigation.navigate("/infoexpedicion", { obj: expedicion })
        }}>
            <SView row
                onPress={() => {
                    if (Mapa.INSTANCE) {
                        if (Mapa.INSTANCE.map) {

                            Mapa.INSTANCE.map.animateToRegion(MDL.backgroundLocation.getMapRegion([
                                {
                                    latitude: parseFloat(expedicion.origen[0].dLatitud ?? "0"),
                                    longitude: parseFloat(expedicion.origen[0].dLongitud ?? "0")
                                },
                                {
                                    latitude: parseFloat(expedicion.destinos[0].dLatitud ?? "0"),
                                    longitude: parseFloat(expedicion.destinos[0].dLongitud ?? "0")
                                },
                            ], 1.3), 1000);
                        }
                    }
                }}>
                <Tag>{expedicion.lExpedicionReal_id}</Tag>
                <SView width={8} />
                <ExpedicionEstado estado={expedicion.estado} />
            </SView>
            <SHr h={4} />
            <SView row>
                <FechaText fecha={fecha_carga} />
                <SView width={16} />
                <SView row center flex style={{
                    justifyContent: "center",
                    alignItems: "center",
                    // backgroundColor: "#f0f"
                }}>
                    <SView flex style={{
                        transform: [{
                            translateY: 8
                        }]
                    }}>
                        <SLoad type='bar' color={STheme.color.lightGray} />
                    </SView>
                    <SView style={{
                        width: 16, height: 16, borderRadius: 100, backgroundColor: STheme.colorFromText(expedicion.lExpedicionReal_id + "" + expedicion.sOrigen),
                        position: "absolute", left: 0
                    }} />
                    <SView style={{
                        width: 16, height: 16,
                        borderRadius: 100, backgroundColor: STheme.colorFromText(expedicion.lExpedicionReal_id + "" + expedicion.sDestino),
                        position: "absolute", right: 0,
                    }} />
                </SView>
                <SView width={16} />
                <FechaText fecha={fecha_descarga} />
            </SView>
            <SHr h={4} />
            <SView row >
                <SText flex={2} fontSize={12} style={{
                }}>{expedicion.sOrigen}</SText>
                <SView flex />
                <SText flex={2} fontSize={12} style={{
                    textAlign: "right",
                }}>{expedicion.sDestino}</SText>
            </SView>


        </SView >
    }
}

const FechaText = ({ fecha = new SDate(), children = null }) => {
    return <SView style={{
        // backgroundColor: "#f0f",
        borderRadius: 2,
    }} row>
        <SText fontSize={12} center style={{ lineHeight: 12, color: STheme.color.lightGray }}>{children}{fecha.toString("dd MONTH\nHH")}</SText>
    </SView>
}

const Tag = ({ children = "", color = STheme.color.lightGray, textColor = STheme.color.text }) => {
    return <View center style={{
        padding: 1,
        paddingLeft: 8,
        paddingRight: 8,
        borderRadius: 4,
        backgroundColor: color + "99",
        borderColor: color,
        borderWidth: 1,
        justifyContent: "center",
        alignItems: "center",
    }}>
        <SText color={textColor} fontSize={12} style={{
            lineHeight: 14,
        }}>{children}</SText>
    </View>
}